module.exports = __webpack_public_path__ + "img/bg-dots-2.728db93f.svg";